import { render } from "./DeveloperItemFileList.vue?vue&type=template&id=c127235c"
import script from "./DeveloperItemFileList.vue?vue&type=script&lang=js"
export * from "./DeveloperItemFileList.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__